import { set_auth, set_user_details } from '@/router/index.js';

const MICROSOFT_EXCHANGE_TICKET_ENDPOINT =
  '/aic_one_api/microsoft_sso/api/microsoft_exchange_ticket_api/';

export default {
  name: 'MicrosoftSSOSuccess',

  mounted() {
    this.exchange_microsoft_ticket();
  },

  methods: {
    async exchange_microsoft_ticket() {
      const ticket = this.get_ticket_from_url();

      if (!ticket) {
        this.redirect_to_login('Microsoft sign-in could not be completed.');
        return;
      }

      try {
        const data = await this.exchange_ticket_with_backend(ticket);

        if (data.status !== 'success') {
          this.redirect_to_login(data.message || 'Microsoft sign-in failed.');
          return;
        }

        this.store_microsoft_session(data.data);
        this.$router.push('/home');
      } catch {
        this.redirect_to_login('Microsoft sign-in failed. Please try again.');
      }
    },

    get_ticket_from_url() {
      const url_params = new URLSearchParams(window.location.search);
      return url_params.get('ticket');
    },

    async exchange_ticket_with_backend(ticket) {
      const url = process.env.VUE_APP_API_BASE_URL + MICROSOFT_EXCHANGE_TICKET_ENDPOINT;

      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-Page-URL': window.location.href,
        },
        body: JSON.stringify({ ticket }),
      });

      return response.json();
    },

    store_microsoft_session(user_data) {
      if (!user_data) {
        return;
      }

      set_auth(user_data.token || '', user_data.user_id || '');
      this.store_user_details(user_data);
      this.store_extra_auth_details(user_data);
      this.mark_otp_as_verified();
    },

    store_user_details(user_data) {
      set_user_details({
        first_name: user_data.first_name || '',
        last_name: user_data.last_name || '',
        email: user_data.email || '',
      });
    },

    store_extra_auth_details(user_data) {
      localStorage.setItem('role_id', user_data.role_id || '');
      localStorage.setItem('client_type_id', user_data.client_type_id || '');
      localStorage.setItem('is_staff', this.format_boolean_value(user_data.is_staff));
      localStorage.setItem('is_superuser', this.format_boolean_value(user_data.is_superuser));
    },

    mark_otp_as_verified() {
      localStorage.setItem('otp_required', '0');
      localStorage.setItem('otp_verified', '1');
    },

    format_boolean_value(value) {
      return value === true ? 'true' : 'false';
    },

    redirect_to_login(message) {
      this.$router.push({
        path: '/login',
        query: {
          microsoft_error: message,
        },
      });
    },
  },
};
